import { DeltaKind, EntityType } from '@airreading/common/data';

export type NormalizedEntityItem = {
  type: EntityType;
  kind: DeltaKind;
  internalId?: string;
  externalId?: string;
  label?: string;
  details?: Record<string, string>;
};

const EXCLUDED_DETAIL_KEYS = ['id', 'orgId', 'externalId', 'kind', 'edlinkId'];

export const cleanEntityItemDetails = (details: Record<string, unknown>): Record<string, string> => {
  return Object.fromEntries(
    Object.entries(details).flatMap(([k, v]) =>
      v != null && !EXCLUDED_DETAIL_KEYS.includes(k)
        ? [[k, typeof v === 'object' ? JSON.stringify(v) : String(v)]]
        : [],
    ),
  );
};
